/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Browser_Does_Not_SupportInputs */

const en_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser does not support the video tag.`)
};

const es_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu navegador no soporta la etiqueta de video.`)
};

const fr_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre navigateur ne prend pas en charge la balise vidéo.`)
};

const de_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Browser unterstützt das Video-Tag nicht.`)
};

const ja_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お使いのブラウザはビデオタグをサポートしていません。`)
};

const zh_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的浏览器不支持该视频标签。`)
};

const ar_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصفحك لا يدعم تشغيل الفيديو.`)
};

const id_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Anda tidak mendukung tag video.`)
};

const it_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo browser non supporta il tag video.`)
};

const ru_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш браузер не поддерживает тег video.`)
};

const pt_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu navegador não suporta a tag de vídeo.`)
};

const ko_your_browser_does_not_support = /** @type {(inputs: Your_Browser_Does_Not_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`귀하의 브라우저는 비디오 태그를 지원하지 않습니다.`)
};

/**
* | output |
* | --- |
* | "Your browser does not support the video tag." |
*
* @param {Your_Browser_Does_Not_SupportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_browser_does_not_support = /** @type {((inputs?: Your_Browser_Does_Not_SupportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Browser_Does_Not_SupportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_browser_does_not_support(inputs)
	if (locale === "es") return es_your_browser_does_not_support(inputs)
	if (locale === "fr") return fr_your_browser_does_not_support(inputs)
	if (locale === "de") return de_your_browser_does_not_support(inputs)
	if (locale === "ja") return ja_your_browser_does_not_support(inputs)
	if (locale === "zh") return zh_your_browser_does_not_support(inputs)
	if (locale === "ar") return ar_your_browser_does_not_support(inputs)
	if (locale === "id") return id_your_browser_does_not_support(inputs)
	if (locale === "it") return it_your_browser_does_not_support(inputs)
	if (locale === "ru") return ru_your_browser_does_not_support(inputs)
	if (locale === "pt") return pt_your_browser_does_not_support(inputs)
	return ko_your_browser_does_not_support(inputs)
});